jQuery(function ($) {

	//loding.jsでの画像読み込みが遅れる対策
	setTimeout(function () {


		// トップページ - メインビジュアル
		$('#p-top-mv__slider').slick({
			autoplay: true,
			fade: true,
			autoplaySpeed: 2000,
			speed: 3000,
			pauseOnHover: true,
			infinite: true,
			lazyLoad: 'progressive',
			dots: false,
			arrows: false,
			// prevArrow: '<span class="slide-arrow prev-arrow"></span>',
			// nextArrow: '<span class="slide-arrow next-arrow"></span>',
			slidesToShow: 1,
			slidesToScroll: 1,

			// レスポンシブ設定
			responsive: [{
				breakpoint: 769,
				settings: {
					slidesToShow: 1,
				}
			}]
		});

		$('#p-top-mv__bnr .slider-field').slick({
			autoplay: true,
			autoplaySpeed: 3000,
			speed: 800,
			pauseOnHover: true,
			infinite: true,
			lazyLoad: 'progressive',
			dots: false,
			arrows: true,
			prevArrow: '<span class="icomoon icomoon--round icon-Icon-ionic-ios-arrow-back arrow--back"></span>',
			nextArrow: '<span class="icomoon icomoon--round icon-Icon-ionic-ios-arrow-forward arrow--forward"></span>',
			slidesToShow: 3,
			slidesToScroll: 1,
			centerMode: true,
			variableWidth: false,
			// レスポンシブ設定
			responsive: [{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
				}
			}]
		});

		$('.slider-linear').slick({
			autoplay: true, //自動でスクロール
			autoplaySpeed: 0, //自動再生のスライド切り替えまでの時間を設定
			speed: 8000, //スライドが流れる速度を設定
			cssEase: "linear", //スライドの流れ方を等速に設定
			slidesToShow: 5, //表示するスライドの数
			swipe: false, // 操作による切り替えはさせない
			arrows: false, //矢印非表示
			pauseOnFocus: false, //スライダーをフォーカスした時にスライドを停止させるか
			pauseOnHover: false, //スライダーにマウスホバーした時にスライドを停止させるか
			responsive: [
				{
					breakpoint: 1023,
					settings: {
						slidesToShow: 2, //画面幅750px以下でスライド3枚表示
					}
				}
			]
		});

		$('#p-top-blog__slider .slider-field').slick({
			autoplay: true,
			autoplaySpeed: 3000,
			speed: 800,
			pauseOnHover: true,
			infinite: true,
			lazyLoad: 'progressive',
			dots: false,
			arrows: true,
			prevArrow: '<span class="icomoon icomoon--round icon-Icon-ionic-ios-arrow-back arrow--back"></span>',
			nextArrow: '<span class="icomoon icomoon--round icon-Icon-ionic-ios-arrow-forward arrow--forward"></span>',
			slidesToShow: 3,
			slidesToScroll: 1,
			centerMode: true,
			variableWidth: false,
			// レスポンシブ設定
			responsive: [
				{
					breakpoint: 1023,
					settings: {
						slidesToShow: 2,
						centerMode: true,
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 1,
						centerMode: true,
					}
				}
			]
		});

		$('#p-single-personaltaraning__voice__slider .slider-field').slick({
			autoplay: true,
			autoplaySpeed: 5000,
			speed: 800,
			pauseOnHover: true,
			infinite: true,
			lazyLoad: 'progressive',
			dots: false,
			arrows: true,
			prevArrow: '<span class="icomoon icomoon--round icon-Icon-ionic-ios-arrow-back arrow--back"></span>',
			nextArrow: '<span class="icomoon icomoon--round icon-Icon-ionic-ios-arrow-forward arrow--forward"></span>',
			slidesToShow: 4,
			slidesToScroll: 1,
			variableWidth: false,
			// レスポンシブ設定
			responsive: [
				{
					breakpoint: 1023,
					settings: {
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 1,
					}
				}
			]
		});

		var mainSlider = "#slider"; //メインスライダーid
		var thumbnailSlider = "#thumbnail_slider"; //サムネイルスライダーid

		$(mainSlider).slick({
			autoplay: true,
			speed: 1000,
			arrows: false,
			asNavFor: thumbnailSlider
		});
		$(thumbnailSlider).slick({
			slidesToShow: 3,
			speed: 1000,
			asNavFor: mainSlider
		});
		//#thumbnail_sliderでクリックしたスライドをカレントにする
		$(thumbnailSlider + " .slick-slide").on('click', function () {
			var index = $(this).attr("data-slick-index");
			$(thumbnailSlider).slick("slickGoTo", index, false);
		});

	}, 1);

	$('.magnific-popup-group__target').on('click', function () {
		// 0.3s 後に setPosition 付きで Slick 実行
		const slickInit = setTimeout(() => {
			const $setPotion = $('#setPotion');
			// Slick
			$('.magnific-popup_slider').not('.slick-initialized').slick({
				autoplay: false,
				speed: 800,
				infinite: true,
				lazyLoad: 'progressive',
				dots: false,
				arrows: true,
				prevArrow: '<span class="icomoon icomoon--round icon-Icon-ionic-ios-arrow-back arrow--back"></span>',
				nextArrow: '<span class="icomoon icomoon--round icon-Icon-ionic-ios-arrow-forward arrow--forward"></span>',
				variableWidth: true,
			});
			$('.magnific-popup_slider').not('.slick-initialized').slick('setPosition');
		}, 1);
	});




	//センタモード使用時の2週目のカクツキをなくす
	const $slider_kakutuki = $(".js-slick-main__center-mode");

	// 左右の透過の2周目ががたつく対応
	$slider_kakutuki.on("beforeChange", (event, slick, currentSlide, nextSlide) => {
		$slider_kakutuki.find(".slick-slide").each((index, el) => {
			const $this = $(el),
				slickindex = $this.attr("data-slick-index");
			if (nextSlide == slick.slideCount - 1 && currentSlide == 0) {
				// 現在のスライドが最初のスライドでそこから最後のスライドに戻る場合
				if (slickindex == "-1") {
					// 最後のスライドに対してクラスを付与
					$this.addClass("is-active-next");
				} else {
					// それ以外は削除
					$this.removeClass("is-active-next");
				}
			} else if (nextSlide == 0) {
				// 次のスライドが最初のスライドの場合
				if (slickindex == slick.slideCount) {
					// 最初のスライドに対してクラスを付与
					$this.addClass("is-active-next");
				} else {
					// それ以外は削除
					$this.removeClass("is-active-next");
				}
			} else {
				// それ以外は削除
				$this.removeClass("is-active-next");
			}
		});
	});


});
